export default __webpack_public_path__ + "media/theresWaldo.c2392130.webm";